import {
  profile,
  researchGroup,
  researchPlatform
} from '@stereoagency/sanity-schema';

const researchGroupQuery = researchGroup.schema.builder
  .filter('references(^._id)')
  .pick(['_type', '_id', 'title', 'slug'])
  .use();

const researchPlatformQuery = researchPlatform.schema.builder
  .filter('references(^._id)')
  .pick(['_type', '_id', 'title', 'slug'])
  .use();

export const profileModalQueryBuilder = profile.schema.builder
  .pick([
    '_id',
    'name',
    'firstName',
    'image',
    'subtitle',
    'introduction',
    'pubmedQuery',
    'pubmedArticles',
    'email',
    'phone',
    'website',
    'socials',
    'address',
    'hideFromListing'
  ])
  .subquery({
    researchGroups: researchGroupQuery,
    researchPlatforms: researchPlatformQuery
  });
